export type SelectOption = {
  title: string;
  value: string | number;
};

export type TimeOption = SelectOption & { hour: number; minute: number };

export const getTimeOptions = (addCurrent = false, minuteInterval = 15, labelPrefix = ''): TimeOption[] => {
  const currentDate = new Date();
  const hoursList: TimeOption[] = [];
  // eslint-disable-next-line fabric-ui/no-let
  for (let hour = 0; hour < 24; hour++) {
    // eslint-disable-next-line fabric-ui/no-let
    for (let minute = 0; minute < 60; minute += minuteInterval) {
      const formattedHour = (hour % 12 || 12).toString().padStart(2, '0');
      const formattedMinute = minute.toString().padStart(2, '0');
      const ampm = hour < 12 ? 'AM' : 'PM';
      const timeObject: TimeOption = {
        title: `${labelPrefix}${formattedHour}:${formattedMinute} ${ampm}`,
        value: `${hour}:${minute}`,
        hour,
        minute,
      };
      hoursList.push(timeObject);
    }
  }

  const currentHour = currentDate.getHours();
  const currentMinute = currentDate.getMinutes();

  return addCurrent
    ? [
        {
          title: 'current',
          value: `${currentHour}:${currentMinute}`,
          hour: currentHour,
          minute: currentMinute,
        },
        ...hoursList,
      ]
    : hoursList;
};
